import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { sessionState } from '@chainlit/react-client';

import { setAccountExpiredModalActive } from '@/api';
import { accountExpiredState, AccountExpiredPayload } from '@/state/project';

/**
 * Headless listener for the backend ``account_expired`` socket event (#1054).
 * Sets the Recoil atom that drives the non-dismissable read-only modal when a
 * temporary account hits its day or token limit mid-session.
 */
export default function AccountExpiredListener() {
  const session = useRecoilValue(sessionState);
  const setPayload = useSetRecoilState(accountExpiredState);

  useEffect(() => {
    const socket = session?.socket;
    if (!socket) return;
    const handler = (payload: AccountExpiredPayload) => {
      setAccountExpiredModalActive(true);
      setPayload(payload);
    };
    socket.on('account_expired', handler);
    return () => {
      socket.off('account_expired', handler);
    };
  }, [session?.socket, setPayload]);

  return null;
}
